import { useQuery } from '@tanstack/react-query';
import { api } from '$api';
import { getMatches, Match } from '$api/dentally/match';

const queryKey = 'dentally-linking-suggestions';

export interface PaymentPlan {
    id: number;
    name: string;
    patient_friendly_name: string;
}

export const useDentallySuggestions = (query: string) => {
    return useQuery({
        queryKey: [queryKey, query],
        queryFn: async () => {
            const suggestions = await getMatches({
                query
            })

            return suggestions.matches as Match[]
        }
    });
};

export const usePaymentPlans = () => {
    return useQuery({
        queryKey: ['dentally-payment-plans'],
        queryFn: async () => {
            const { data } = await api.get('/dentally/payment-plans');
            return data as PaymentPlan[];
        }
    });
};

export const useEthnicityCodes = () => {
    return useQuery({
        queryKey: ['dentally-ethnicity-codes'],
        queryFn: async () => {
            const { data } = await api.get('/dentally/ethnicity-codes');
            return data as Record<string, string>;
        }
    });
};

export const usePatientTitles = () => {
    return useQuery({
        queryKey: ['dentally-patient-titles'],
        queryFn: async () => {
            const { data } = await api.get('/dentally/patient-titles');
            return data as string[];
        }
    });
};
